import React from "react";
import AnimationsContainer from "../../components/animationsContainer";
import { SPORTS_HAVING_ANIMATIONS, H2H_STATS_PER_SPORT, SPORTS_HAVING_STATS_TABLE, SPORTS_HAVING_TIMELINE } from "../../../constants/sportsInfo";
import { hasVideo } from "../../../helpers/sport/videoFilter";
import { t } from "../../../helpers/translator";
import Expandable from "../expandable";
import LiveGameScore from "../../../../dev/components/liveGameScore";
import LiveGameH2HChart from "../../../../dev/components/liveGameH2HChart";
import LiveGameStatsTable from "../../../../dev/components/liveGameStatsTable";
import LiveGameTimeline from "../../../../dev/components/liveGameTimeline";
import GameInfo from "../../components/gameInfo";
import Helpers from "../../../helpers/helperFunctions";
import Config from "../../../config/main";

export default function animationWrapperTemplate () {
    let { userData, data, sportAlias, gameType, expandedElements, lang, isVirtualGame, showType } = this.props,
        hasH2H = !!H2H_STATS_PER_SPORT[sportAlias],
        hasStats = !!SPORTS_HAVING_STATS_TABLE[sportAlias],
        hasTL = !!SPORTS_HAVING_TIMELINE[sportAlias],
        isDualscreen = sessionStorage.getItem("dualscreen");
    return Config.animatinAndChartEnabled ? <>
        {isDualscreen === "true" || Helpers.isSplitScreenAvailable() ? null : <AnimationsContainer loggedIn={userData.loggedIn}
            balance={userData.balance}
            hasVideo={hasVideo(data)}
            videoLoadStarted={this.videoDataLoaded}
            hasAnimation={gameType === "live" && SPORTS_HAVING_ANIMATIONS[sportAlias]}
            game={data}
            sportAlias={sportAlias}
            streamURL={this.videoData}
            key={sportAlias} />}

        {!isVirtualGame && gameType === "live" ? <div className="animation-stat-tabs">
            <Expandable className={"view-game-additional-info " + ((hasH2H + hasStats + hasTL) === 0 ? "one" : "")} key={9} uiKey="gi_score" openAnywhere={true}>{t("Score")}</Expandable>
            { isDualscreen !== "true" && hasH2H ? <Expandable className="view-game-additional-info" uiKey="gi_h2h" key={6} openAnywhere={true}>{t("H2H Chart")}</Expandable> : null}
            { isDualscreen !== "true" && hasStats ? <Expandable className="view-game-additional-info" uiKey="gi_stats" key={7} openAnywhere={true}>{t("Stats")}</Expandable> : null}
            { isDualscreen !== "true" && hasTL ? <Expandable className="view-game-additional-info" uiKey="gi_timeline" key={8} openAnywhere={true}>{t("Timeline")}</Expandable> : null}
        </div> : null}

        {!isVirtualGame && gameType === "live" && expandedElements.gi_score ? <LiveGameScore game={data} isDualscreen={isDualscreen} sportAlias={sportAlias} key={data.id}/> : null}
        
        {isDualscreen !== "true" && !isVirtualGame && gameType === "live" && expandedElements.gi_h2h ? <LiveGameH2HChart stats={data.stats} sportAlias={sportAlias} /> : null}
        
        {isDualscreen !== "true" && !isVirtualGame && gameType === "live" && expandedElements.gi_stats ? <LiveGameStatsTable stats={data.stats} team1_name={data.team1_name} team2_name={data.team2_name} sportAlias={sportAlias} /> : null}
        
        {isDualscreen !== "true" && !isVirtualGame && gameType === "live" && expandedElements.gi_timeline ? <LiveGameTimeline game={data} sportAlias={sportAlias} /> : null}
        
        {isDualscreen !== "true" && !isVirtualGame && gameType !== "live" ? <GameInfo showType={showType} game={data} language={lang} /> : null}
        
        {!isVirtualGame && data.text_info ? <div className="game-view-title-contain-m additional-info">
            <p className="additional-game-info">
                {data.info.hasOwnProperty("add_info") ? `${data.info.add_info} | ` : null} {data.text_info}
            </p>
        </div> : null}
    </> : null;
}